import { RegisterCallbackData, useEvent, useState } from 'hooks'
import { debounce } from 'utils'
import axios from 'axios'
import { Loader } from 'component'
import { fileRights } from './constant'
import { getFileRightsComponents, getExpandCarets } from './selector'
import { Highlighter } from './highlighter/highlighter'

type State = {
	sections: NodeListOf<HTMLSelectElement>
}

export const FileRights = (() => {
	const { state, setState } = useState<State>()

	const initFileLoader = () => {
		const { sections } = state

		if (sections.length === 0) {
			return
		}

		sections.forEach((section) => {
			const carets = getExpandCarets(section)

			carets.forEach((element) => {
				const change = useEvent<MouseEvent>(element, 'click')
				change.register(
					debounce((eventData: RegisterCallbackData<MouseEvent>) => {
						eventData.e.preventDefault()

						const fileManager = element.closest<HTMLElement>(fileRights.selector.fileManagerSection)

						if (fileManager === null) {
							return
						}

						const blockId = fileManager.getAttribute(fileRights.attribute.blockId)
						const targetUrl = fileManager.getAttribute(fileRights.attribute.url)

						const path = element.getAttribute(fileRights.attribute.path)
						const level = element.getAttribute(fileRights.attribute.level)

						if (targetUrl === null || blockId === null || path === null || level === null) {
							return
						}

						const data = new FormData()
						data.append('blockId', blockId)
						data.append('path', path)
						data.append('level', level)

						Loader.create(fileManager, { absolute: true })

						axios
							.post(targetUrl, data)
							.then((response) => {
								const row = element.closest<HTMLElement>('tr')

								if (row === null) {
									return
								}

								const nextRow = document.createElement('template')
								nextRow.innerHTML = response.data.template

								nextRow.content.childNodes.forEach((childNode) => {
									row.after(childNode)
								})

								init()
							})
							.finally(() => {
								Loader.destroy(fileManager)
							})
							.catch()
					}),
				)
			})
		})
	}

	const init = () => {
		setState({ ...getFileRightsComponents() })

		initFileLoader()
		Highlighter.init()
	}

	return {
		init,
	}
})()
